import InputMask from "react-input-mask";

export function InputMatricula({ value, onChange, ...rest }) {
  return (
    <InputMask
      className="ant-input"
      mask="999999-9-*"
      onChange={(e) => {
        if ( e.target.value && e.target.value )
          onChange( e.target.value );
      }}
      value={value}
    />
  );
}
